import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout"
import BioAgeSubCard from "./Clock/BioAgeSubCard";
import PhenoAgeCockpit from "./PhenoAge/PhenoAgeCockpit";
import PhenoAgeDashboard from "./PhenoAge/PhenoAgeDashboard";
import { useTheme } from "@mui/material";
import { useTranslation } from "../../../../language";


export default function BioAgeWelcome() {
   
 const theme = useTheme();
 const { t, language } = useTranslation();
        
 

return (

<PageProtectedLayout
    
    headline = {t("age_1")} 
    specify = {t("age_2")}

     >
 
 {/* Main Page Content */}
      
       <PhenoAgeCockpit />

</PageProtectedLayout>

)}